import * as actionTypes from "../../constants";
import { ApiBase } from "../../../utils/apiBase";
import { RENAME_PROJECT_URL } from "../../../../config/constants";
import { getProjectIdAndOrgId } from '../../../utils/apiUtils';

export function renameProject(payload, callback) {
  return (dispatch) => {
    dispatch({ type: actionTypes.RENAME_PROJECT_START });
    const axios = new ApiBase().instance;
    axios
      .post(RENAME_PROJECT_URL, { ...payload, ...getProjectIdAndOrgId(payload) })
      .then((res) => {
        dispatch({ type: actionTypes.RENAME_PROJECT_SUCCESS, response: res });
        callback && callback();
        renameProjectSuccess.bind(null, dispatch, payload);
      })
      .catch((err) =>
        dispatch({
          type: actionTypes.RENAME_PROJECT_FAIL,
          response: err,
        })
      );
  };
}

function renameProjectSuccess(dispatch, payload, response) {
  return dispatch({
    type: actionTypes.RENAME_PROJECT_SUCCESS,
    response,
    requestPayload: payload,
  });
}
